import { render, staticRenderFns } from "./FilterDepartmentsModal.vue?vue&type=template&id=6c682c86&scoped=true"
import script from "./FilterDepartmentsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterDepartmentsModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilterDepartmentsModal.vue?vue&type=style&index=0&id=6c682c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c682c86",
  null
  
)

export default component.exports